var currentTab = 0; // Current tab is set to be the first tab (0)
var total_steps;

var point_score = {
  'cotton-sateen': 0,
  'bamboo-sateen': 0,
  'french-linen': 0
}

$(function(){

  initPageQuiz();
  $('#switch-cm').on('click', function(){
    $('.in').hide();
    $('.cm').fadeIn();
    $(this).addClass('active');
    $('#switch-in').removeClass('active');
  })

  $('#switch-in').on('click', function(){
    $('.cm').hide();
    $('.in').fadeIn();
    $(this).addClass('active');
    $('#switch-cm').removeClass('active');
  })

  scrollToTop();
})
// When the user clicks the button, open the modal
openPop = (evt) =>{
  var $this = $(evt);
  $('#sizePopup').css('display','block');
}

initPageQuiz = () => {

  var _check =$('#js_template').val();
  if (_check.includes('page.quiz')) {
    showTab(currentTab); // Display the current tab
  }

}

scrollToTop = () =>{
  // ===== Scroll to Top ====
  $(window).scroll(function() {
    if ($(this).scrollTop() >= 50) {        // If page is scrolled more than 50px
      $('.scroll-to-top').fadeIn(200);    // Fade in the arrow
    } else {
      $('.scroll-to-top').fadeOut(200);   // Else fade out the arrow
    }
  });
  $('.scroll-to-top').click(function() {      // When arrow is clicked
    $('body,html').animate({
        scrollTop : 0                       // Scroll to top of body
    }, 500);
  });
}

function showTab(n) {
  // This function will display the specified tab of the form...
  var x = document.getElementsByClassName("tab");
  x[n].style.display = "block";
  //... and fix the Previous/Next buttons:
  if (n == 0) {
    document.getElementById("prevBtn").style.display = "none";
  } else {
    document.getElementById("prevBtn").style.display = "inline";
  }
  if (n == (x.length - 1)) {
    document.getElementById("nextBtn").innerHTML = "Submit";
  } else {
    document.getElementById("nextBtn").innerHTML = "Next";
  }
  //... and run a function that will display the correct step indicator:
  fixStepIndicator(n)
}

function nextPrev(n) {
  // This function will figure out which tab to display
  var x = document.getElementsByClassName("tab");

  x[currentTab].style.display = "none";
  currentTab = currentTab + n;

  if (currentTab >= x.length) {
    $('.Button').hide();
    endCheck();
  }
  else {
    showTab(currentTab);
  }


}

function fixStepIndicator(n) {

  // This function removes the "active" class of all steps...
  var i, x = document.getElementsByClassName("step");
  for (i = 0; i < x.length; i++) {
    x[i].className = x[i].className.replace(" active", "");
  }
  //... and adds the "active" class on the current step:
  x[n].className += " active";


}

// When the user clicks on <span> (x), close the modal
closePop = () =>{
  $('#sizePopup').css('display','none');
}


function endCheck() {
  for (var i = 1; i < 6; i++) {
    if($('input:radio[name=step'+i+']:checked').data('bamboo-sateen') == 1) {
      point_score['bamboo-sateen'] +=1;
    }
    if($('input:radio[name=step'+i+']:checked').data('cotton-sateen') == 1) {
      point_score['cotton-sateen'] +=1;
    }
    if($('input:radio[name=step'+i+']:checked').data('french-linen') == 1) {
      point_score['french-linen'] +=1;
    }
  }

  if (point_score['cotton-sateen'] > point_score['french-linen']) {
    if (point_score['bamboo-sateen'] >= point_score['cotton-sateen']){
      window.location.href ='/pages/quiz-results-bamboo';
    }
    else {
      window.location.href ='/pages/quiz-results-cotton';
    }
  }
  else{
    if (point_score['bamboo-sateen'] >= point_score['french-linen']) {
      window.location.href ='/pages/quiz-results-bamboo';
    }
    else {
      window.location.href =' /pages/quiz-results-linen';
    }
  }
}
